import React, { useState, useEffect } from 'react';
import { RoleApi } from '../../services/ApiService';

function CreateRole() {
  const [roleName, setRoleName] = useState('');
  const [message, setMessage] = useState('');
  const [roles, setRoles] = useState([]);

  // Fetch existing roles on mount
  useEffect(() => {
    async function fetchRoles() {
      try {
        const response = await RoleApi.getRoles();
        const data = await response.json();
        if (response.ok) {
          setRoles(data);
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    }
    fetchRoles();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('CreateRole: Submitting role with name:', roleName);
    
    try {
      const requestData = { roleName: roleName };
      console.log('CreateRole: Request data:', requestData);
      
      const response = await RoleApi.createRole(requestData);
      console.log('CreateRole: API response status:', response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('CreateRole: API error response:', errorText);
        setMessage(errorText || "Failed to create role.");
        return;
      }
      
      const data = await response.json();
      console.log('CreateRole: Success response:', data);
      
      setMessage("Role created successfully!");
      setRoles([...roles, data]);
      setRoleName(''); // Clear the form
    } catch (error) {
      console.error('CreateRole: Exception occurred:', error);
      setMessage("An error occurred. Please try again.");
    }
  };

  return (
    <div>
      <h3>Manage Roles</h3>
      <div>
        <h4>Existing Roles:</h4>
        {roles.length === 0 ? (
          <p>No roles found.</p>
        ) : (
          <ul>
            {roles.map((role) => (
              <li key={role.roleId}>
                {role.roleName} (Created: {new Date(role.createdAt).toLocaleString()})
              </li>
            ))}
          </ul>
        )}
      </div>
      <hr />
      <h4>Create Role</h4>
      <form onSubmit={handleSubmit}>
        <label>Role Name:</label>
        <input 
          type="text"
          value={roleName}
          onChange={(e) => setRoleName(e.target.value)}
          required 
        />
        <button type="submit">Create</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
}

export default CreateRole;